import { PencilSimpleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Editor = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <PencilSimpleIcon size={Sizes[size]} {...rest} color={fill} />;
};

Editor.displayName = 'Editor';
